import Vuex from 'vuex'
import Vue from 'vue'
import routers from './modules/routers'
import login from './modules/login'
import loading from './modules/loading'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules:{
    routers,
    login,
    loading
  },
  getters
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js